
import { GlowEffect } from '@/components/ui/glow-effect';
import { ReactNode, forwardRef } from 'react';
import { cn } from '@/lib/utils';
import { Button, ButtonProps } from '@/components/ui/button';

interface GlowButtonProps extends ButtonProps {
  glowColors?: string[];
  glowMode?: 'rotate' | 'pulse' | 'breathe' | 'colorShift' | 'flowHorizontal' | 'static';
  glowBlur?: 'softest' | 'soft' | 'medium' | 'strong' | 'stronger' | 'strongest' | 'none';
  glowScale?: number;
  glowDuration?: number;
  children: ReactNode;
}

export const GlowButton = forwardRef<HTMLButtonElement, GlowButtonProps>(({
  glowColors = ['#1EAEDB', '#33C3F0', '#0EA5E9', '#8B5CF6', '#D946EF'],
  glowMode = 'colorShift',
  glowBlur = 'medium', 
  glowScale = 1.4,    
  glowDuration = 6,
  className,
  children,
  ...props
}, ref) => {
  return (
    <div className="relative inline-block">
      <GlowEffect
        colors={glowColors}
        mode={glowMode}
        blur={glowBlur}
        duration={glowDuration}
        scale={glowScale}
      />
      <Button
        className={cn(
          "relative z-10 backdrop-blur-sm bg-opacity-90 shadow-lg", // Added shadow for more prominence
          className
        )}
        ref={ref}
        {...props}
      >
        {children}
      </Button>
    </div>
  );
});

GlowButton.displayName = 'GlowButton';
